import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from 'react-intl';
import utils from "../utils/utils";
import {Link, withRouter} from "react-router-dom";
import DATE_FORMAT from "../components/constants/dateFormat";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faReceipt} from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import {pdf} from "@react-pdf/renderer";
import { saveAs } from 'file-saver';
import MarketplaceAdminBillPdfDocument from "./marketplaceAdminBillPdfDocument";

const MarketplaceAdminBillsIndex = ({bills, match, intl}) => {
  return (
    <div className="panel">
      <div className="panel__corner">
        <FontAwesomeIcon icon={faReceipt}/>
      </div>
      <h6 className="panel__title">
        <FormattedMessage id={'marketplace.admin.bills.header'}/>
      </h6>

      <table className="table table-striped admin__table">
        <thead>
        <tr>
          <th scope="col">
            <FormattedMessage id={'marketplace.admin.bills.table.title'}/>
          </th>
          <th scope="col">
            <FormattedMessage id={'marketplace.admin.bills.table.total'}/>
          </th>
          <th scope="col">
            <FormattedMessage id={'marketplace.admin.bills.table.status'}/>
          </th>
          <th scope="col">
            <FormattedMessage id={'marketplace.admin.bills.table.deadline'}/>
          </th>
          <th scope="col">
            <FormattedMessage id={'marketplace.admin.bills.table.actions'}/>
          </th>
        </tr>
        </thead>
        <tbody>

        {
          bills.map((bill, itemIndex) => {
            const deadline = utils.getDateFromString(bill.deadline);
            const formattedDeadline = deadline ? deadline.format(DATE_FORMAT.display) : '-';

            const now = utils.getNowDate();
            const inThreeDays = utils.getNowDate();
            inThreeDays.add(3, "days");

            const deadlineClasses = classNames({
              "text-warning": bill.status !== 'PAID' && deadline && deadline.isBefore(inThreeDays),
              "text-danger": bill.status !== 'PAID' && deadline && deadline.isBefore(now),
            });

            const pdfCopy = utils.getPdfCopy(intl, bill);

            return (
              <tr key={itemIndex}>
                <th scope="row">
                  <Link className="link" to={`${match.url}/view/${bill.id}`}>
                    {bill.title}
                  </Link>
                </th>
                <td>
                  {bill.amount}€
                </td>
                <td>
                  {bill.status === 'PAID'? (<FormattedMessage id={'marketplace.admin.bills.table.status.paid'}/>): ''}
                </td>
                <td className={deadlineClasses}>
                  {formattedDeadline}
                </td>
                <td>
                  <Link className="link" to={`${match.url}/view/${bill.id}`}>
                    <FormattedMessage id={'marketplace.admin.bills.table.actions.view'}/>
                  </Link> <br/>
                  <button className="btn btn-normal-link" onClick={async () => {
                    const doc = <MarketplaceAdminBillPdfDocument bill={bill} copy={pdfCopy}/>;
                    const asPdf = pdf(); // {} is important, throws without an argument
                    asPdf.updateContainer(doc);
                    const blob = await asPdf.toBlob();
                    saveAs(blob, `${bill.title}.pdf`);
                  }}>
                    <FormattedMessage id={'marketplace.admin.bills.table.actions.download'}/>
                  </button>
                </td>
              </tr>
            );
          })
        }
        </tbody>
      </table>
    </div>
  );
}

MarketplaceAdminBillsIndex.propTypes = {
  bills: PropTypes.array.isRequired,
};

MarketplaceAdminBillsIndex.defaultProps = {};

export default injectIntl(withRouter(MarketplaceAdminBillsIndex));